function a(e,r,t){var n=r-e;return(n+(t-e)%n)%n+e}export{a as wrap};
//# sourceMappingURL=index.js.map
